export default __webpack_public_path__ + "static/media/circle.54484cff.svg";